import { siteConfig } from "../config/siteConfig";
import { MapPin, Navigation } from "lucide-react";

export default function NearbyDestinations() {
  const list = siteConfig.nearbyDestinations || [];

  return (
    <section
      id="nearby"
      data-testid="nearby-section"
      className="section bg-[#F3EFE6]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 reveal">
          <div>
            <p className="font-overline mb-4">Around You</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A362D] leading-tight">
              Sacred Sites Nearby
            </h2>
            <div className="gold-divider mt-4"></div>
          </div>
          <p className="text-[#2C2C2C] max-w-md text-base sm:text-lg">
            Step out of Thuruliya and into 2,000 years of living history — the
            world's oldest stupas, sacred trees and stone temples are minutes away.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 sm:grid-cols-6 gap-4 lg:gap-5">
          {list.map((d, i) => {
            const span = [
              "sm:col-span-3 lg:col-span-4 lg:row-span-2 min-h-[420px]",
              "sm:col-span-3 lg:col-span-2",
              "sm:col-span-3 lg:col-span-2",
              "sm:col-span-3 lg:col-span-2 lg:row-span-2 min-h-[420px]",
              "sm:col-span-3 lg:col-span-2",
              "sm:col-span-6 lg:col-span-2",
            ];
            return (
              <article
                key={d.id}
                data-testid={`nearby-${d.id}`}
                className={`reveal group relative overflow-hidden rounded-3xl bg-[#1A362D] min-h-[220px] ${span[i] || "sm:col-span-3 lg:col-span-2"}`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <img
                  src={d.image}
                  alt={d.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />

                <div className="absolute top-4 left-4">
                  <span className="text-[10px] uppercase tracking-[0.22em] px-3 py-1 rounded-full bg-[#FAF9F6]/15 backdrop-blur-md text-[#FAF9F6] border border-[#FAF9F6]/20">
                    {d.tag}
                  </span>
                </div>

                <div className="absolute top-4 right-4 flex items-center gap-1.5 text-[10px] uppercase tracking-[0.22em] px-3 py-1 rounded-full bg-[#C5A059]/95 text-[#1A362D] font-medium">
                  <Navigation className="w-3 h-3" strokeWidth={2} />
                  {d.distance}
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-7 text-[#FAF9F6]">
                  <div className="flex items-center gap-2 mb-2">
                    <MapPin className="w-4 h-4 text-[#C5A059]" strokeWidth={1.5} />
                    <span className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">
                      Anuradhapura
                    </span>
                  </div>
                  <h3 className="font-display text-2xl sm:text-3xl mb-2">
                    {d.name}
                  </h3>
                  <p className="text-sm text-[#FAF9F6]/85 leading-relaxed line-clamp-2">
                    {d.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
